import { format, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from 'theme'
import { format as formatPrice } from 'utils/price'

const Invoices = ({
  invoices,
}) => (
  <Wrapper>
    <Title>
      MES FACTURES
    </Title>
    <InvoiceList>
      { invoices.map(({
        createdAt,
        amount,
        pdfUrl,
      }, index) => (
        <Invoice key={ index }>
          <Date>
            {format(parseISO(createdAt), 'd MMMM yyyy', { locale: fr })}
          </Date>
          <Cost>
            { `${formatPrice(amount)}` }
          </Cost>
          <PDFContainer>
            <Link href={ pdfUrl }>
              PDF
            </Link>
          </PDFContainer>
        </Invoice>
      ),
      )}
    </InvoiceList>
  </Wrapper>
)

Invoices.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      pdfUrl: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.span`
  margin: 0.5rem 0 2rem;
  font-family: Montserrat;
  font-size: 1rem;
  font-weight: 800;
  color: ${colors.midnightBlue};
`

const InvoiceList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0 0 1rem;
  list-style-type: none;
`

const Invoice = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  height: 2rem;
  border-bottom: 1px solid ${colors.lightGray};

   &:hover {
    background-color: ${colors.lightGray};
  }
`

const Date = styled.span`
  font-family: 'brother-1816';
  font-size: 0.875rem;
  color: ${colors.midnightBlue};
`

const Cost = styled.span`
  font-family: 'brother-1816';
  font-size: 0.875rem;
  text-align: right;
  color: ${colors.midnightBlue};
`

const Link = styled.a`
  font-family: 'brother-1816';
  font-size: 0.875rem;
  text-decoration: underline;
  text-align: right;
`

const PDFContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  height: 100%;
`

export default Invoices
